import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Home from './pages';
import RequestDemo from './components/RequestDemo';

function App() {
  return (
    <Router>
      <Routes >
        <Route path='/' element={<Home />} />
        <Route path='/request_call' Component={RequestDemo} />
      </Routes>
    </Router>
  );
}

export default App;
